import { selectedValues } from 'snippets/plp-native/@store'
import { FILTER_SELECTORS } from 'libs/search-native/search-native-utils'
import PlpNativeFilterItems from 'snippets/plp-native/plp-native-filter-items/plp-native-filter-items'
import PlpNativeFilterPrice from 'snippets/plp-native/plp-native-filter/plp-native-filter-price'

function PlpNativeFilterGroup ({ field, getLocalSelected }) {
  const key = selectedValues.value[field.field]
  const isFilterPrice = field.type === FILTER_SELECTORS.type.range

  return (
    <div className={`space-y-6 ${!isFilterPrice && 'pb-4 pt-2'}`}>
      {isFilterPrice
        ? (
          <PlpNativeFilterPrice key={key} field={field} getLocalSelected={getLocalSelected} />
          )
        : (
          <PlpNativeFilterItems key={key} field={field} getLocalSelected={getLocalSelected} />
          )}
    </div>
  )
}

export default PlpNativeFilterGroup
